import {
  Box,
  Button,
  Container,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import logo from "../assets/logo.png";
import { Call } from "@mui/icons-material";

const AGENTS = {
  bruin_equipment_cold: {
    id: "agent_9a219d4c780f0847b3e9b63325",
    label: "Bruin Equipment — Cold Call (Machinery Resale)",
    description:
      "Qualifies prospects who own construction or farming equipment and transfers them to a specialist for a quote.",
  },
  bruin_energy_cold: {
    id: "agent_1aa5ea057849b3279a77899287",
    label: "Bruin Energy — Cold Call (Fuel Cost Optimization)",
    description:
      "Qualifies business prospects (trucking, farming, construction) for a free fuel cost review and transfers them to a live Bruin Energy advisor.",
  },
};

const FROM_NUMBER = "14313059330"; // Canadian number — 431 Winnipeg, MB
const BASE_URL =
  "https://initiateretellcall-655075094783.us-central1.run.app";

export const BorealBruin = () => {
  const [selectedAgent, setSelectedAgent] = useState("bruin_equipment_cold");
  const [firstName, setFirstName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [country, setCountry] = useState("ca");
  const [status, setStatus] = useState(null); // null | "loading" | "success" | "error"

  const agent = AGENTS[selectedAgent];

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!agent.id) {
      alert("This agent is not configured yet.");
      return;
    }

    setStatus("loading");

    const url = `${BASE_URL}?lead_first_name=${encodeURIComponent(
      firstName
    )}&first_name=${encodeURIComponent(
      firstName
    )}&to_number=${phoneNumber}&from_number=${FROM_NUMBER}&agent_id=${agent.id}`;

    try {
      await axios.request(url, {
        method: "GET",
        headers: {
          "ngrok-skip-browser-warning": "69420",
          "Access-Control-Allow-Origin": "*",
        },
      });
      setStatus("success");
    } catch (err) {
      console.error(err);
      setStatus("error");
    }
  };

  return (
    <div className="full-page-background">
      <Grid item xs={12} md={7}>
        <Container className="App" maxWidth="sm">
          <img src={logo} className="App-logo" alt="logo" />
          <h1>Boreal Bruin — AI Agent Demo</h1>
          <h3>Select an agent, enter a first name and phone number, then trigger the call.</h3>

          <form onSubmit={handleSubmit}>
            {/* Agent selector */}
            <FormControl fullWidth margin="normal">
              <Select
                value={selectedAgent}
                onChange={(e) => {
                  setSelectedAgent(e.target.value);
                  setStatus(null);
                }}
                sx={{ backgroundColor: "white", borderRadius: "4px" }}
              >
                {Object.entries(AGENTS).map(([key, a]) => (
                  <MenuItem key={key} value={key}>
                    {a.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Agent description */}
            <Typography
              variant="body2"
              sx={{
                color: "rgba(255,255,255,0.8)",
                mb: 1,
                mt: 0.5,
                fontStyle: "italic",
              }}
            >
              {agent.description}
            </Typography>

            {/* First name */}
            <TextField
              label="First Name"
              variant="filled"
              sx={{ backgroundColor: "white", borderRadius: "4px" }}
              fullWidth
              margin="normal"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />

            {/* Phone number */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={3}>
                <FormControl fullWidth margin="normal">
                  <Select
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                    sx={{ backgroundColor: "white", borderRadius: "4px" }}
                  >
                    <MenuItem value="ca">🇨🇦 (+1)</MenuItem>
                    <MenuItem value="us">🇺🇸 (+1)</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={9}>
                <Box width="100%">
                  <br />
                  <PhoneInput
                    country={country}
                    value={phoneNumber}
                    disableDropdown={true}
                    disableCountryGuess={true}
                    onChange={setPhoneNumber}
                    enableLongNumbers={true}
                    inputStyle={{
                      width: "100%",
                      textAlign: "center",
                      fontSize: "16px",
                      height: "56px",
                      borderRadius: "4px",
                      border: "1px solid #ced4da",
                    }}
                    required
                  />
                </Box>
              </Grid>
            </Grid>

            <br />
            <Typography
              variant="body2"
              sx={{ color: "rgba(255,255,255,0.9)", mb: 2 }}
            >
              You will receive a call from: <b>+1 (431) 305-9330</b>
            </Typography>

            {status === "success" && (
              <Typography sx={{ color: "#4caf50", mb: 1, fontWeight: "bold" }}>
                ✓ Call initiated successfully!
              </Typography>
            )}
            {status === "error" && (
              <Typography sx={{ color: "#f44336", mb: 1, fontWeight: "bold" }}>
                ✗ Something went wrong. Check the console.
              </Typography>
            )}

            <Button
              className="callBtn"
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={status === "loading" || !agent.id}
            >
              <h2 style={{ fontSize: "16px" }}>
                {status === "loading" ? "Initiating call..." : "Click here to receive the DEMO call"}
              </h2>
              <div style={{ width: "20px" }} />
              <Call className="callIcon" />
            </Button>
          </form>
        </Container>
      </Grid>
    </div>
  );
};
